<div class="row mt-3">
  <div class="col-lg-12 mb-3">
    <h5>Report Management</h5>
  </div>
  <div class="col-lg-12">
    <div class="row">
      <div class="col-lg-12">
        <ul class="nav nav-tabs" role="tablist">
          <li class="nav-item"> <a class="nav-link active" data-toggle="tab" href="#timeperyear" role="tab"><span class="hidden-sm-up"><i class="ti-user"></i></span>
          <span class="hidden-xs-down">Timesheet per Year</span></a> </li>
          <li class="nav-item"> <a class="nav-link" data-toggle="tab" href="#detailmt" role="tab"><span class="hidden-sm-up"><i class="ti-user"></i></span>
          <span class="hidden-xs-down">Detailed Monthly Timesheet</span></a> </li>
        </ul>
      </div>
      <div class="col-lg-12">
        <div class="tab-content tabcontent-border">
          <div class="tab-pane white-bg active" id="timeperyear" role="tabpanel">
            <div class="row p-3">
              <div class="col-lg-12">
                <div class="card card_dash">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-lg-5"><h3>Timesheet per Year</h3></div>
                      <div class="col-lg-2"></div>
                      <div class="col-lg-2">
                        <div class="form-group has-float-label">
                          <select class="form-control" [(ngModel)]="search.YEAR" (ngModelChange)="onInputChange($event)">
                            <option>SELECT</option>
                            @for (item of listYear; track item) {
                              <option value="{{item.YEAR}}">{{item.YEAR}}</option>
                            }
                          </select>
                          <label for="">Year</label>
                        </div>
                      </div>
                      <div class="col-lg-12 table-responsive">
                        <p-table
                          [value]="listTimesheetPerYear"
                          [paginator]="false"
                          [lazy]="true"
                          [scrollable]="true"
                          class="report-table"
                          >
                          <ng-template pTemplate="header" let-columns>
                            <tr>
                              <th class="ng-table-header" rowspan="2">User</th>
                              <th class="ng-table-header" colspan="12">Date</th>
                            </tr>
                            <tr>
                              <th class="ng-table-header">January</th>
                              <th class="ng-table-header">February</th>
                              <th class="ng-table-header">March</th>
                              <th class="ng-table-header">April</th>
                              <th class="ng-table-header">May</th>
                              <th class="ng-table-header">June</th>
                              <th class="ng-table-header">July</th>
                              <th class="ng-table-header">August</th>
                              <th class="ng-table-header">September</th>
                              <th class="ng-table-header">October</th>
                              <th class="ng-table-header">November</th>
                              <th class="ng-table-header">December</th>
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="body" let-rowData let-columns="columns">
                            <tr class="ng-table-body">
                              <td class="text-center">{{ rowData.USER_NAME }}</td>
                              <td class="text-center">{{ rowData.JANUARY | number:'1.2-2' }}</td>
                              <td class="text-center">{{ rowData.FEBRUARY | number:'1.2-2' }}</td>
                              <td class="text-center">{{ rowData.MARCH | number:'1.2-2' }}</td>
                              <td class="text-center">{{ rowData.APRIL | number:'1.2-2' }}</td>
                              <td class="text-center">{{ rowData.MAY | number:'1.2-2' }}</td>
                              <td class="text-center">{{ rowData.JUNE | number:'1.2-2' }}</td>
                              <td class="text-center">{{ rowData.JULY | number:'1.2-2' }}</td>
                              <td class="text-center">{{ rowData.AUGUST | number:'1.2-2' }}</td>
                              <td class="text-center">{{ rowData.SEPTEMBER | number:'1.2-2' }}</td>
                              <td class="text-center">{{ rowData.OCTOBER | number:'1.2-2' }}</td>
                              <td class="text-center">{{ rowData.NOVEMBER | number:'1.2-2' }}</td>
                              <td class="text-center">{{ rowData.DECEMBER | number:'1.2-2' }}</td>
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="emptymessage">
                            <tr>
                              <td colspan="13">Records not found!</td>
                            </tr>
                          </ng-template>
                        </p-table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane white-bg" id="detailmt" role="tabpanel">
            <div class="row p-3">
              <div class="col-lg-12">
                <div class="card card_dash">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-lg-5"><h3>Detailed Monthly Timesheet</h3></div>
                      <div class="col-lg-2"></div>
                      <div class="col-lg-2">
                        <div class="form-group has-float-label">
                          <select class="form-control" [(ngModel)]="searchDet.YEAR" (ngModelChange)="onInputChangeDet($event)">
                            <option>SELECT</option>
                            @for (item of listYear; track item) {
                              <option value="{{item.YEAR}}">{{item.YEAR}}</option>
                            }
                          </select>
                          <label for="">Year</label>
                        </div>
                      </div>
                      <div class="col-lg-2">
                        <div class="form-group has-float-label">
                          <select class="form-control" [(ngModel)]="searchDet.MONTH" (ngModelChange)="onInputChangeDet($event)">
                            <option>SELECT</option>
                            @for (item of listMonth; track item) {
                              <option value="{{item.MONTH_NUMBER}}">{{item.MONTH_NUMBER}}</option>
                            }
                          </select>
                          <label for="">Month</label>
                        </div>
                      </div>
                      <div class="col-lg-12 table-responsive">
                        <p-table
                          [value]="listTimesheetDetPerYear"
                          [paginator]="false"
                          [lazy]="true"
                          [scrollable]="true"
                          class="report-table"
                          >
                          <ng-template pTemplate="header" let-columns>
                            <tr>
                              <th class="ng-table-header">User</th>
                              <th class="ng-table-header">Origin</th>
                              <th class="ng-table-header">Initiative Title</th>
                              <th class="ng-table-header">WorkItemId</th>
                              <th class="ng-table-header">Wi Type</th>
                              <th class="ng-table-header">Workitemname</th>
                              <th class="ng-table-header">Grand</th>
                              @for (i of [].constructor(31); track i; let d = $index) {
                                <th class="ng-table-header">{{ d + 1 }}</th>
                              }
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="body" let-rowData let-columns="columns">
                            <tr class="ng-table-body">
                              <td scope="col" class="text-center">{{ rowData.USER }}</td>
                              <td scope="col" class="text-center">{{ rowData.ORIGIN }}</td>
                              <td scope="col" class="text-center">{{ rowData.INITIATIVE_TITLE }}</td>
                              <td scope="col" class="text-center">{{ rowData.WORKITEMID }}</td>
                              <td scope="col" class="text-center">{{ rowData.WI_TYPE }}</td>
                              <td scope="col" class="text-center">{{ rowData.WORKITEMNAME }}</td>
                              <td scope="col" class="text-center" style="max-width: 20px;">{{ rowData.GRAND | number:'1.2-2'  }}</td>

                              <!-- Days 1 to 31 -->
                              <td scope="col" class="text-center" style="max-width: 20px;">{{ rowData.DAY1 }}</td>
                              <td scope="col" class="text-center" style="max-width: 20px;">{{ rowData.DAY2 }}</td>
                              <td scope="col" class="text-center" style="max-width: 20px;">{{ rowData.DAY3 }}</td>
                              <td scope="col" class="text-center" style="max-width: 20px;">{{ rowData.DAY4 }}</td>
                              <td scope="col" class="text-center" style="max-width: 20px;">{{ rowData.DAY5 }}</td>
                              <td scope="col" class="text-center" style="max-width: 20px;">{{ rowData.DAY6 }}</td>
                              <td scope="col" class="text-center" style="max-width: 20px;">{{ rowData.DAY7 }}</td>
                              <td scope="col" class="text-center" style="max-width: 20px;">{{ rowData.DAY8 }}</td>
                              <td scope="col" class="text-center" style="max-width: 20px;">{{ rowData.DAY9 }}</td>
                              <td scope="col" class="text-center" style="max-width: 20px;">{{ rowData.DAY10 }}</td>
                              <td scope="col" class="text-center" style="max-width: 20px;">{{ rowData.DAY11 }}</td>
                              <td scope="col" class="text-center" style="max-width: 20px;">{{ rowData.DAY12 }}</td>
                              <td scope="col" class="text-center" style="max-width: 20px;">{{ rowData.DAY13 }}</td>
                              <td scope="col" class="text-center" style="max-width: 20px;">{{ rowData.DAY14 }}</td>
                              <td scope="col" class="text-center" style="max-width: 20px;">{{ rowData.DAY15 }}</td>
                              <td scope="col" class="text-center" style="max-width: 20px;">{{ rowData.DAY16 }}</td>
                              <td scope="col" class="text-center" style="max-width: 20px;">{{ rowData.DAY17 }}</td>
                              <td scope="col" class="text-center" style="max-width: 20px;">{{ rowData.DAY18 }}</td>
                              <td scope="col" class="text-center" style="max-width: 20px;">{{ rowData.DAY19 }}</td>
                              <td scope="col" class="text-center" style="max-width: 20px;">{{ rowData.DAY20 }}</td>
                              <td scope="col" class="text-center" style="max-width: 20px;">{{ rowData.DAY21 }}</td>
                              <td scope="col" class="text-center" style="max-width: 20px;">{{ rowData.DAY22 }}</td>
                              <td scope="col" class="text-center" style="max-width: 20px;">{{ rowData.DAY23 }}</td>
                              <td scope="col" class="text-center" style="max-width: 20px;">{{ rowData.DAY24 }}</td>
                              <td scope="col" class="text-center" style="max-width: 20px;">{{ rowData.DAY25 }}</td>
                              <td scope="col" class="text-center" style="max-width: 20px;">{{ rowData.DAY26 }}</td>
                              <td scope="col" class="text-center" style="max-width: 20px;">{{ rowData.DAY27 }}</td>
                              <td scope="col" class="text-center" style="max-width: 20px;">{{ rowData.DAY28 }}</td>
                              <td scope="col" class="text-center" style="max-width: 20px;">{{ rowData.DAY29 }}</td>
                              <td scope="col" class="text-center" style="max-width: 20px;">{{ rowData.DAY30 }}</td>
                              <td scope="col" class="text-center" style="max-width: 20px;">{{ rowData.DAY31 }}</td>
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="emptymessage">
                            <tr>
                              <td colspan="6">Records not found!</td>
                            </tr>
                          </ng-template>
                        </p-table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
